<template>
  <v-container style="max-width: 1800px !important;">
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>
    <v-row style="max-width: 1800px !important;">
      <v-col
        v-if="!error_534"
        cols="12"
      >
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
        >
          <template v-slot:[`item.fotografia`]="{ item }">
            <v-container>  
              <br>
              <v-img
                height="200"
                :src="(item.fotografia != null) ? `/api/archivos/pacientes/${item.fotografia}?jwt=${token}` : '/img/persona.jpg'"
                contain
                width="200"
              ></v-img>
            </v-container>
          </template>
          <template v-slot:[`item.nombre_completo`]="{ item }">
            {{item.nombre}} {{item.apellido_paterno}} {{item.apellido_materno}}
          </template>
          <template v-slot:[`item.signos_vitales`]="{ item }">
            <div>
              <v-icon
                color="green darken-2"
              >
                mdi-weight-kilogram
              </v-icon>
              <span class="text-body-2">
                Peso: {{ item.signos_vitales.peso }} Kg
              </span>
            </div>
            <div>
              <v-icon
                color="blue darken-2"
              >
                mdi-human-male-height-variant
              </v-icon>
              <span class="text-body-2">
                Estatura: {{ item.signos_vitales.estatura }} m
              </span>
            </div>
            <div>
              <v-icon
                color="purple darken-2"
              >
                mdi-percent-outline
              </v-icon>
              <span class="text-body-2">
                IMC: {{ item.signos_vitales.imc }}
              </span>
            </div>
            <div
              v-if="item.signos_vitales.cintura != null"
            >
              <v-icon
                color="teal darken-2"
              >
                mdi-tape-measure
              </v-icon>
              <span class="text-body-2">
                Cintura: {{ item.signos_vitales.cintura }} cm
              </span>
            </div>
            <div>
              <v-icon
                color="blue-grey darken-2"
              >
                mdi-thermometer
              </v-icon>
              <span class="text-body-2">
                Temperatura: {{ item.signos_vitales.temperatura }}° C
              </span>
            </div>
            <div>
              <v-icon
                color="red darken-2"
              >
                mdi-heart
              </v-icon>
              <span class="text-body-2">
                Pulso: {{ item.signos_vitales.pulso }} ppm
              </span>
            </div>
            <div>
              <v-icon
                color="orange darken-2"
              >
                mdi-lungs
              </v-icon>
              <span class="text-body-2">
                Respiración: {{ item.signos_vitales.respiracion }} rpm
              </span>
            </div>
            <div>
              <v-icon
                color="indigo darken-2"
              >
                mdi-counter
              </v-icon>
              <span class="text-body-2">
                Oximetría: {{ item.signos_vitales.oximetria }}% Sp02
              </span>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <template v-if="item.en_progreso == true">
              <v-icon color="green" x-large>mdi-progress-check</v-icon>
              <span class="text-subtitle-1 green--text">En Progreso</span>
              <br>
            </template>
            <template v-if="item.nivel_urgencia == 1">
              <v-icon color="green" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 green--text">Normal</span>
            </template>
            <template v-if="item.nivel_urgencia == 2">
              <v-icon color="yellow" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 yellow--text">Prioridad</span>
            </template>
            <template v-if="item.nivel_urgencia == 3">
              <v-icon color="orange" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 orange--text">Urgencia</span>
            </template>
            <template v-if="item.nivel_urgencia == 4">
              <v-icon color="red" x-large>mdi-ambulance</v-icon>
              <span class="text-subtitle-1 red--text">Emergencia</span>
            </template>

            <v-btn
              color="green"
              class="white--text"
              block
              @click="iniciarConsulta(item)"
            >
              Iniciar Interpretación
            </v-btn>
          </template>

        </v-data-table>
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <v-row>
          <v-col cols="12">
            <lottie :options="loadingAnimation" :height="250" :width="500" />
          </v-col>
        </v-row>
        <div class="text-body-1 text-justify">
          Para poder utilizar Mi UBGA y realizar interpretaciones radiológicas, es necesario que nos proporcione la siguiente información: su nombre completo, especialidad, subespecialidad, cédula profesional y firma. Estos datos son requeridos ya que usted es un médico radiólogo, y son indispensables para el correcto llenado de las interpretaciones radiológicas. Una vez que haya proporcionado esta información, podrá hacer uso del sistema.
        </div>
        <br>
        <v-row>
          <v-col cols="2">
            <v-autocomplete
              v-model="radiologo.titulo"
              label="Titulo"
              :items="titulos"
              item-value="nombre"
              item-text="nombre"
              outlined
              dense
              hide-details
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="10" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0">
              <v-col cols="4">
                <v-text-field
                  v-model="radiologo.nombre"
                  label="Nombre"
                  dense
                  hide-details
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="radiologo.apellido_paterno"
                  label="Apellido Paterno"
                  dense
                  hide-details
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="radiologo.apellido_materno"
                  label="Apellido Materno"
                  dense
                  hide-details
                  outlined
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="radiologo.cedula"
              label="Cédula Profesional"
              dense
              hide-details
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="radiologo.especialidad"
              label="Especialidad"
              dense
              hide-details
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="radiologo.subespecialidad"
              label="Subespecialidad"
              dense
              hide-details
              outlined
            >
            </v-text-field>
          </v-col>
          
          <v-col
            cols="12"
          >
            <v-card>
              <v-card-text>
                <TopazSignatureImage
                  ref="radiologo"
                  id="radiologo"
                ></TopazSignatureImage>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="red"
              block
              @click="save"
              :loading="saving"
              :disabled="saving"
              class="white--text"
            >
              <v-icon>
                mdi-content-save
              </v-icon>
              Guardar información
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <consulta
      ref="consulta"
      @complete="finalizarConsulta"
    >
    </consulta>
  </v-container>
</template>

<script>
import Consulta from './Consulta.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import Lottie from 'vue-lottie';
import animationData from '@/assets/stop.json';
import TopazSignatureImage from '@/components/TopazSignatureImage.vue';

export default {
  components: {
    Consulta,
    'lottie': Lottie,
    TopazSignatureImage
  },
  computed: {
    ...mapState(['token'])
  },
  data: () => ({
    headers: [
      {
        text: "Fotografia",
        value: "fotografia",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Folio",
        value: "folio",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Nombre Completo",
        value: "nombre_completo",
        align: "center",
        width: "15%",
        sortable: false,
      },
      {
        text: "Edad",
        value: "edad",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Sexo",
        value: "sexo",
        align: "center",
        width: "10%",
        sortable: false,
      },
      {
        text: "Signos Vitales",
        value: "signos_vitales",
        align: "center",
        width: "15%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false,
      },
    ],
    items: [],
    loading: false,
    countupOptions: {
      suffix: ' Consultas'
    },
    normal: 0,
    prioridad: 0,
    urgencia: 0,
    emergencia: 0,
    error_534: false,
    loadingAnimation: {animationData: animationData},
    radiologo: {
      titulo: null,
      apellido_paterno: null,
      apellido_materno: null,
      nombre: null,
      cedula: null,
      especialidad: null,
      subespecialidad: null,
      firma: null,
    },
    defaultRadiologo: {
      titulo: null,
      apellido_paterno: null,
      apellido_materno: null,
      nombre: null,
      cedula: null,
      especialidad: null,
      subespecialidad: null,
      firma: null,
    },
    saving: false,
    titulos: [
      { nombre: 'Dra.'},
      { nombre: 'Dr.'},
    ],
    mostrar_firma: false,
  }),
  mounted() {
    this.getInterpretacionesRadiologicas();
  },
  methods: {
    getItems(){
      this.getInterpretacionesRadiologicas();
    },
    getInterpretacionesRadiologicas(){
      this.loading = true;
      this.items = [];

      axios
      .get('/InterpretacionesRadiologicas/ListarConsultas')
      .then(response => {
        this.items = response.data.interpretaciones;
        this.consultaEnProgreso();
        this.error_534 = false;
      })
      .catch(error => {
        if (error.response.status == 534) this.error_534 = true;
      })
      .finally(() => {
        this.loading = false;
      })
    },
    consultaEnProgreso(){
      axios
      .get('/InterpretacionesRadiologicas/ConsultaEnProgreso')
      .then(response => {
        if(response.data != null && response.data.length > 0){
          this.$refs.consulta.iniciarConsulta(response.data)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    iniciarConsulta(item){
      this.$refs.consulta.iniciarConsulta(item.id_paciente_servicio);
      this.getInterpretacionesRadiologicas();
    },
    finalizarConsulta(){
      this.getInterpretacionesRadiologicas();
    },

    obtenerInfo(){
      axios
      .get(`/Radiologos/ObtenerDatosBasicos`)
      .then(response => {
        this.radiologo.apellido_paterno = response.data.apellido_paterno;
        this.radiologo.apellido_materno = response.data.apellido_materno;
        this.radiologo.nombre = response.data.nombre;
      })
      .catch(error => {
        console.log(error)
      })
    },
    save(){
      if (this.radiologo.titulo == null || this.radiologo.titulo <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar un Titulo");
        this.$refs.alert.open();
        return;
      }

      if (this.radiologo.nombre == null || this.radiologo.nombre.length <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar su Nombre");
        this.$refs.alert.open();
        return;
      }

      if (this.radiologo.apellido_paterno == null || this.radiologo.apellido_paterno.length <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar su Apellido Paterno");
        this.$refs.alert.open();
        return;
      }

      if (this.radiologo.apellido_materno == null || this.radiologo.apellido_materno.length <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar su Apellido Materno");
        this.$refs.alert.open();
        return;
      }

      if (this.radiologo.cedula == null || this.radiologo.cedula.length <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar su Cédula Profesional");
        this.$refs.alert.open();
        return;
      }


      if (this.radiologo.especialidad == null || this.radiologo.especialidad.length <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar su Especialidad");
        this.$refs.alert.open();
        return;
      }

      if (this.radiologo.subespecialidad == null || this.radiologo.subespecialidad.length <= 0) {
        this.$refs.alert.setMessage("", "Debe ingresar su Subespecialidad");
        this.$refs.alert.open();
        return;
      }

      if (this.$refs.radiologo.isEmpty()) {
        this.$refs.alert.setMessage("", "Debe ingresar una Firma.");
        this.$refs.alert.open();
        return;
      }

      this.saving = true;
      axios
      .put(`/Radiologos/ActualizarDatosRadiologo`,{
        id_usuario: this.radiologo.id_usuario,
        titulo: this.radiologo.titulo,
        nombre: this.radiologo.nombre,
        apellido_paterno: this.radiologo.apellido_paterno,
        apellido_materno: this.radiologo.apellido_materno,
        cedula: this.radiologo.cedula,
        especialidad: this.radiologo.especialidad,
        subespecialidad: this.radiologo.subespecialidad,
        firma: this.$refs.radiologo.save()
      })
      .then(() => {
        this.radiologo = Object.assign({}, this.defaultRadiologo);
        this.getInterpretacionesRadiologicas();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.saving = false;
      })
    }
  }
}
</script>